import { takeLatest, call, put } from 'redux-saga/effects';
import { listarVagas, filtrarVagas } from 'services/vagas';
import { Types } from '../ducks/vagas';
import { Types as AppTypes } from '../ducks/app';

function* listarVagasAsync({ payload }) {
  try {
    yield put({ type: AppTypes.SET_VAGAS_LOADING });

    const vagas = yield call(listarVagas, payload);
    const buildPayload = {
      data: vagas.data.data.vagas,
      count: vagas.data.data.count,
      links: vagas.data.data.links,
    };
    yield put({ type: Types.sync.LISTAR, payload: buildPayload });
    yield put({ type: AppTypes.SET_VAGAS_LOADING_FiNISHED });
  } catch (e) {
    yield put({ type: '', message: e.message });
  }
}

function* filtrarVagasAsync({ payload }) {
  try {
    const vagas = yield call(filtrarVagas, payload);
    const buildPayload = {
      data: vagas.data.data.vagas,
      count: vagas.data.data.count,
      links: vagas.data.data.links,
    };
    yield put({ type: Types.sync.FILTRAR, payload: buildPayload });
  } catch (e) {
    yield put({ type: '', message: e.message });
  }
}

function* vagasSaga() {
  yield takeLatest(Types.async.LISTAR, listarVagasAsync);
  yield takeLatest(Types.async.FILTRAR, filtrarVagasAsync);
}

export default vagasSaga;
